import { useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatTelefono } from "../../helpers/formatTelefono";
import PhoneHelpIcon from "../../assets/images/PhoneHelpIcon";

export const HelpInfo = (props) => {
  const { telefono_informacion } = useSelector((state) => state.auth);

  const { t } = useTranslation();

  const [tel, setTel] = useState(
    telefono_informacion !== null
      ? telefono_informacion
      : props.telefono_informacion !== null &&
        props.telefono_informacion !== undefined
      ? props.telefono_informacion
      : t("ayuda.telefono")
  );

  return (
    <Col lg={3} className={`header-help ${props.className}`}>
      <span className="d-none d-lg-block header-help-text">
        {t("header.help.text")}
      </span>
      <span className="header-help-phone">
        <a className="header-help-link" href={`tel:${tel}`}>
          <PhoneHelpIcon color="#db0b27" size={23} />
          <span className="d-none d-lg-inline" style={{ lineHeight: "23px" }}>
            {formatTelefono(tel)}
          </span>
        </a>
      </span>
    </Col>
  );
};
